import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Radio, Input, TextArea, Checkbox } from 'semantic-ui-react';

import { LoadingBar } from 'components/Commons';

import * as com_action from 'actions/company';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class NoticeDtl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: 'N',
      isPush: 'N',
      title: '',
      content: '',
      textCount: 0,
      isLoading: false
    };
  }

  async componentWillReceiveProps(nextProps) {
    const { detail } = this.props;

    if (detail) {
      const { notice } = detail.data;
      await this.setState({
        isOpen: notice.status === true ? 'Y' : 'N',
        isPush: notice.hasOwnProperty('push_status') && notice.push_status === true ? 'Y' : 'N',
        title: notice.title,
        content: notice.content,
        textCount: notice.content.length
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state !== nextState;
  }

  //입력 값 변경
  handleChange = (e, { name, value }) => {
    let result = value;
    if (name === 'content') {
      if (result.length > 0 && result.length > 2000) {
        toastr('top-right', 'warning', '2000자 이하로 입력해주세요.');
        result = result.substring(0, 2000);
      }
      this.setState({ textCount: result.length });
    } else if (name === 'title') {
      if (result.length > 0 && result.length > 30) {
        toastr('top-right', 'warning', '30자 이하로 입력해주세요.');
        result = result.substring(0, 30);
      }
    }
    this.setState({ [name]: result });
  };

  //공지사항 수정
  handleSubmit = async (e, { id }) => {
    e.preventDefault();
    const { isOpen, title, content } = this.state;

    let status = isOpen === 'Y' ? true : false;

    try {
      const params = {
        notice: {
          status: status,
          title: title,
          content: content
        }
      };
      this.setState({ isLoading: true });
      const { comAPI } = this.props;
      comAPI.noticeMod(id, params);

      const { moveToList } = this.props.DetailFn;

      setTimeout(() => {
        moveToList();
        this.setState({ isLoading: false });
      }, 1000);
    } catch (e) {
      console.log('###### e : ', e);
      this.setState({ isLoading: false });
      toastr('top-right', 'error', '일시적인 오류로 공지사항을 수정하지 못했습니다. 다시 시도해주세요.');
    }
  };

  handleCancel = () => {
    this.setState({
      isOpen: 'N',
      isPush: 'N',
      title: '',
      content: ''
    });

    const { moveToList } = this.props.DetailFn;
    moveToList();
  };

  render() {
    const { isOpen, isPush, title, content, textCount, isLoading } = this.state,
      { detail } = this.props;

    let id = 0;
    if (detail) {
      const { notice } = detail.data;
      id = notice.id;
    }

    return isLoading ? (
      <LoadingBar />
    ) : (
      <div>
        <div className="notice_row">
          <div className="notice_tit">공개여부</div>
          <div className="notice_cont">
            <Radio label="노출함" name="isOpen" value="Y" checked={'Y' === isOpen} onChange={this.handleChange} />
            <Radio label="노출 안함" name="isOpen" value="N" checked={'N' === isOpen} onChange={this.handleChange} />
          </div>
        </div>
        <div className="notice_row">
          <div className="notice_tit">제목</div>
          <div className="notice_cont">
            <Input name="title" value={title} onChange={this.handleChange} />
          </div>
        </div>
        <div className="notice_row">
          <div className="notice_tit">
            <span>내용</span>
            <span style={{ position: 'fixed', right: '30px' }}>{textCount + ' / 2000자'}</span>
          </div>
          <TextArea name="content" value={content} onChange={this.handleChange} maxLength={2001} />
        </div>
        <div className="notice_row btn-group">
          <Button inverted color="grey" onClick={this.handleCancel} content="취소" />
          <Button positive content="완료" id={id} onClick={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

NoticeDtl = connect(
  (state) => ({
    detail: state.company.detail,
    result: state.company.result
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        noticeDtl: com_action.NoticeDtl,
        noticeMod: com_action.NoticeMod
      },
      dispatch
    )
  })
)(NoticeDtl);

export default NoticeDtl;
